<template>
  <div class="page-wrapper">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <LogisticsTypeModal
      :show="showLogisticsModal"
      :onCancel="handleModalClose"
      @save="handleLogisticsSave"
      :initialLogisticsType="currentLogisticsType"
    />

    <div class="page-breadcrumb" v-if="showBreadcrumb">
      <div class="row">
        <div class="col-sm-8 col-lg-8 align-self-center col-12">
          <ul class="breadcrumb mb-2 list-style-none">
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link
                class="mylink text-capitalize"
                :to="'/dispatch/overview'"
                >{{ $t("overview") }}</router-link
              >
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link
                class="mylink text-capitalize"
                :to="'/dispatch/contacts'"
                >{{ $t("contact-list") }}</router-link
              >
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link
                class="mylink text-capitalize"
                :to="'/dispatch/drivers'"
                >{{ $t("drivers") }}</router-link
              >
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link
                class="mylink text-capitalize"
                :to="'/dispatch/partners'"
                >{{ $t("partners") }}</router-link
              >
            </li>
            <li
              class="breadcrumb-item h6 font-16 mylink"
              style="margin-right: 3rem"
            >
              <router-link
                class="mylink text-capitalize"
                :to="'/dispatch/vehicles'"
                >{{ $t("vehicles") }}</router-link
              >
            </li>
          </ul>
        </div>

        <div class="col-sm-4 col-lg-4 align-self-center col-12">
          <button class="btn d-block ml-auto btn-primary" @click="btnClicked">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
    <router-view
      :showModal="showModal"
      :closeModal="closeModal"
      :handleShowModal="btnClicked"
    />
    <footer class="footer text-center">
      &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
    </footer>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import LogisticsTypeModal from "../Modals/SelectLogisticsModal.vue";

export default {
  name: "Dispatch",
  components: {
    Loading,
    LogisticsTypeModal,
  },
  computed: {
    btnLabel() {
      let label = "";
      switch (this.$route.name) {
        case "DispatchOverview":
          return this.$t("add-dispatch");
        case "DispatchContacts":
          return this.$t("add-contact");
        case "DispatchVehicles":
          return this.$t("add-vehicle");
        case "DispatchDrivers":
          return this.$t("add-driver");
        case "DispatchPartners":
          return this.$t("add-partner");
        default:
          return label;
      }
    },
    showBreadcrumb() {
      const hideBreadcrumbPaths = [
        "/dispatch/overview/order",
        "/dispatch/drivers/",
      ];

      return !hideBreadcrumbPaths.some((path) => {
        return this.$route.path.startsWith(path);
      });
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      showModal: false,
      showLogisticsModal: false,
      currentLogisticsType: ""
    };
  },
  methods: {
    btnClicked() {
      if (this.$route.name === "DispatchOverview") {
        this.showLogisticsModal = true;
      } else {
        this.showModal = !this.showModal;
      }
    },
    handleModalClose() {
      this.showLogisticsModal = false;
    },
    closeModal() {
      this.showModal = false;
    },
    handleLogisticsSave(selectedLogisticsType) {
      this.showLogisticsModal = false;
      // Perform routing based on selectedLogisticsType
      if (selectedLogisticsType) {
        console.log(selectedLogisticsType); 
        this.$router.push({path: `/dispatch/add-dispatch`, query: { selectedLogisticsType: selectedLogisticsType }});
        console.log(selectedLogisticsType)
      } else return
    }
  },
};
</script>


<style scoped>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
</style>

<i18n>
  {
    "en": {
      "add-contact": "Add Contact",
      "add-dispatch": "Add Dispatch"
     
    },
    "es": {
      "add-contact": "Agregar contacto",
      "add-dispatch": "Agregar Despacho"
    },
    "fr": {
      "add-contact": "Ajouter un contact",
      "add-dispatch": "Ajouter un Envoi"
    },
    "sw": {
      "add-contact": "Ongeza Mawasiliano",
      "add-dispatch": "Ongeza Kutuma"
    }
  }
  </i18n>
